const Browse = () => {

    return <h1>Browse</h1>;
}

export default Browse;